import { ApiService } from './api.service'
import { getAppUrl } from './http-constants'
import VueCookies from 'vue-cookies'
import base64url from 'base64url'

export function login(username: string, password: string) {
    removeToken()
    const apiService = new ApiService()
    return apiService.login(username, password)
}

export function getInfo(token: string) {
    return JSON.parse(localStorage.getItem('user'))
}

export function getUserOperations(idUser) {
    const apiService = new ApiService()
    return apiService.getBuyerOperations(idUser)
}

export function logout() {
    return removeToken()
}

export function getToken() {
    return localStorage.getItem('tokenKey')
}

export function setToken(token: string) {
    return localStorage.setItem('tokenKey', token)
}

export function removeToken() {
    localStorage.removeItem('tokenKey')
    localStorage.removeItem('userOperations')
}

export function verifyToken(token) {
    if (token === null) {
        token = ''
    }
    const parts = token.split('.')
    if (parts.length != 3) {
        return {
            success: false,
            message: "L'authentification n'a pas fonctionnée",
            data: null,
        }
    }
    const decoded = base64url.decode(parts[1])
    if (!decoded) {
        return {
            success: false,
            message: "L'authentification n'a pas fonctionnée",
            data: null,
        }
    }
    return { success: true, message: '', data: JSON.parse(decoded) }
}
